/**
 * The keyboard's way to a context menu: Shift+F10 or the ContextMenu key on a
 * focused element opens its menu under the element's start edge.
 *
 * @module contextMenuKey
 */

import type { ContextMenuPosition } from "@amoreg/contracts";

type MenuKeyEvent = Pick<KeyboardEvent, "key" | "shiftKey" | "altKey" | "ctrlKey" | "metaKey">;

export const isContextMenuKey = (event: MenuKeyEvent) =>
  event.key === "ContextMenu" || (event.key === "F10" && event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey);

/**
 * Where the menu opens when the event is the menu key, else null. Show the
 * menu synchronously in the keydown: on Windows the browser's own contextmenu
 * follows the key, and it must land on the menu's focused item, which the menu
 * swallows, not on the row, which would open a second menu.
 */
export function contextMenuKeyPosition(
  event: MenuKeyEvent,
  element: Pick<Element, "getBoundingClientRect">,
): ContextMenuPosition | null {
  if (!isContextMenuKey(event)) return null;
  const rect = element.getBoundingClientRect();
  return { x: rect.left, y: rect.bottom, fromKeyboard: true };
}
